const HISTORY = "history";
const SETTINGS = "settings";

export { HISTORY, SETTINGS };
